<template>
  <header class="pd-hdr">
    <div class="pd-hdr__left">
      <button class="pd-hdr__hamburger" @click="$emit('toggle-sidebar')">
        <i class="fa-solid fa-bars"></i>
      </button>
      <div class="pd-hdr__titles">
        <h1 class="pd-hdr__title">{{ title }}</h1>
        <p class="pd-hdr__subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div class="pd-hdr__actions">
      <!-- Sync Status & Button -->
      <div class="pd-hdr__sync-group" style="display: flex; align-items: center; gap: 8px; margin-right: 16px;">
        <span class="pd-hdr__sync-date" style="font-size: 11px; opacity: 0.7; max-width: 120px; line-height: 1.2;">
          Última act: <br> <b>{{ lastSyncDate || 'Desconocida' }}</b>
        </span>
        <button class="pd-hdr__btn" @click="$emit('sync-data')" :disabled="isSyncing" style="padding: 6px 10px;">
          <i class="fa-solid fa-sync" :class="{ 'fa-spin': isSyncing }"></i>
          <span v-if="!isSyncing" style="margin-left: 4px;">Sincronizar</span>
          <span v-else style="margin-left: 4px;">Sincronizando...</span>
        </button>
      </div>
      
      <!-- Theme Toggle -->
      <div class="pd-hdr__theme-group">
        <button
          v-for="m in themes" :key="m.value"
          class="pd-hdr__theme-btn"
          :class="{ 'pd-hdr__theme-btn--active': themeMode === m.value }"
          :title="m.label"
          @click="$emit('theme-changed', m.value)"
        ><i :class="m.icon"></i></button>
      </div>
      <button class="pd-hdr__btn pd-hdr__btn--ai" @click="$emit('ai-audit')">
        <i class="fa-solid fa-brain"></i>
        <span>Auditoría de Precios con IA</span>
      </button>
      <button class="pd-hdr__btn pd-hdr__btn--outline" @click="$emit('export-excel')">
        <i class="fa-solid fa-file-excel" style="color: #10B981;"></i>
        <span>Exportar Excel</span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'DashboardHeader',
  props: {
    title:        { type: String, required: true },
    subtitle:     { type: String, required: true },
    themeMode:    { type: String, default: 'system' },
    isSyncing:    { type: Boolean, default: false },
    lastSyncDate: { type: String, default: null },
  },
  data() {
    return {
      themes: [
        { value: 'light',  icon: 'fa-solid fa-sun',           label: 'Modo Claro' },
        { value: 'system', icon: 'fa-solid fa-circle-half-stroke', label: 'Modo Sistema' },
        { value: 'dark',   icon: 'fa-solid fa-moon',          label: 'Modo Oscuro' },
      ],
    };
  },
};
</script>

<style scoped>
.pd-hdr {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 14px 28px !important;
  background: #fff !important;
  border-bottom: 1px solid #E2E8F0 !important;
  box-shadow: 0 1px 4px rgba(0,0,0,.06) !important;
  flex-shrink: 0 !important;
  gap: 16px !important;
}
.pd-hdr__left {
  display: flex !important;
  align-items: center !important;
  gap: 14px !important;
  min-width: 0 !important;
}
.pd-hdr__hamburger {
  display: none !important;
  background: none !important;
  border: none !important;
  cursor: pointer !important;
  color: #475569 !important;
  font-size: 20px !important;
  padding: 4px !important;
  flex-shrink: 0 !important;
}
@media (max-width: 1023px) { .pd-hdr__hamburger { display: flex !important; } }

.pd-hdr__titles { min-width: 0 !important; }
.pd-hdr__title {
  font-size: 15px !important;
  font-weight: 700 !important;
  color: #1E293B !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  line-height: 1.2 !important;
}
.pd-hdr__subtitle {
  font-size: 11px !important;
  color: #64748B !important;
  font-weight: 400 !important;
  margin-top: 2px !important;
  line-height: 1.3 !important;
}

/* Actions */
.pd-hdr__actions { display: flex !important; align-items: center !important; gap: 8px !important; flex-shrink: 0 !important; }

.pd-hdr__btn {
  display: inline-flex !important;
  align-items: center !important;
  gap: 7px !important;
  padding: 8px 16px !important;
  border-radius: 10px !important;
  border: none !important;
  cursor: pointer !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  font-family: 'Inter', sans-serif !important;
  white-space: nowrap !important;
  transition: all .15s ease !important;
  text-decoration: none !important;
}
.pd-hdr__btn--ai {
  background: linear-gradient(135deg, #065F46, #0A5C36) !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(10,92,54,.25) !important;
}
.pd-hdr__btn--ai:hover { background: linear-gradient(135deg, #047857, #065F46) !important; }

.pd-hdr__btn--outline {
  background: #fff !important;
  color: #475569 !important;
  border: 1px solid #E2E8F0 !important;
}
.pd-hdr__btn--outline:hover { background: #F8FAFC !important; }
.pd-hdr__btn--outline i { color: #94A3B8 !important; }

@media (max-width: 768px) {
  .pd-hdr {
    flex-direction: column !important;
    align-items: flex-start !important;
    padding: 12px 16px !important;
    gap: 12px !important;
  }
  .pd-hdr__left {
    width: 100% !important;
    align-items: flex-start !important;
  }
  .pd-hdr__hamburger {
    margin-top: -2px !important; /* Alinear el icono con la primera línea del título */
  }
  .pd-hdr__title {
    font-size: 14px !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    line-height: 1.3 !important;
  }
  .pd-hdr__subtitle {
    display: none !important; /* Escondemos el subtítulo en móvil para ahorrar espacio */
  }
  .pd-hdr__actions {
    width: 100% !important;
    justify-content: flex-start !important;
    flex-wrap: wrap !important;
    gap: 10px !important;
  }
  .pd-hdr__sync-group {
    margin-right: 0 !important;
    flex-grow: 1 !important;
  }
  .pd-hdr__btn span { display: none !important; }
  .pd-hdr__btn { padding: 8px 12px !important; justify-content: center !important; }
}
/* Theme toggle group */
.pd-hdr__theme-group {
  display: flex !important;
  align-items: center !important;
  background: #F1F5F9 !important;
  border-radius: 10px !important;
  padding: 3px !important;
  gap: 2px !important;
}
.pd-hdr__theme-btn {
  width: 30px !important; height: 30px !important;
  border-radius: 7px !important;
  border: none !important;
  cursor: pointer !important;
  background: transparent !important;
  color: #94A3B8 !important;
  font-size: 12px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all .15s ease !important;
}
.pd-hdr__theme-btn:hover { background: #E2E8F0 !important; color: #475569 !important; }
.pd-hdr__theme-btn--active {
  background: #fff !important;
  color: #0A5C36 !important;
  box-shadow: 0 1px 3px rgba(0,0,0,.12) !important;
}
</style>
